"use client";

import { createContext, type ReactNode, useContext } from "react";

const ChatHistoryToggleButtonContext = createContext<ReactNode>(null);

type Props = {
  children: ReactNode;
  value: ReactNode;
};

export function ChatHistoryToggleButtonProvider({ children, value }: Props) {
  return (
    <ChatHistoryToggleButtonContext.Provider value={value}>
      {children}
    </ChatHistoryToggleButtonContext.Provider>
  );
}

export function useChatHistoryToggleButton(): ReactNode {
  return useContext(ChatHistoryToggleButtonContext);
}
